import infoPagesLinks from '@/helpers/infoPagesLinks'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      mainMenuPresence: 'settings/mainMenuPresence',
      mainMenuTitles: 'settings/mainMenuTitles',
    }),

    mainMenuLinks() {
      return infoPagesLinks.filter(page => this.mainMenuPresence[page.page_presence_setting_name])
        .map(page => ({
          ...page,
          text: this.mainMenuTitles[page.page_title_setting_name] || page.text,
        }))
    },

    hasMainMenuLinks() {
      return ['about_us', 'delivery_and_payment', 'blog', 'offers'].some(pageName => this.mainMenuPresence[pageName])
    }
  },
}
